import { render, staticRenderFns } from "./_MarginCard.vue?vue&type=template&id=72be9dec"
import script from "./_MarginCard.vue?vue&type=script&lang=js"
export * from "./_MarginCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports